import React, { useContext } from "react";
import { AuthContext } from "src/utils/AuthContext.js";
import {
  Typography,
  Box,
  Icon,
} from "@mui/material";
import PaymentForm from "./PaymentForm.js";
import { useTheme } from "@emotion/react";
import { Helmet } from "react-helmet";
import CountdownTimer from "src/components/blocks/CountdownTimer.js";

const NativeCheckout = ({
  type = "consumer_annual",
  trialPeriodDays = 7,
  successUrl,
}) => {
  const { user } = useContext(AuthContext);
  const theme = useTheme();



  return (
    <>
      <Helmet>
        <title>Stanza - Payment Checkout</title>
      </Helmet>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          id="container"
          sx={{
            margin: "0 auto 0 auto",
            maxWidth: { xs: "100%", sm: "400px" },
            width: { xs: "-webkit-fill-available", sm: "100%" },
            position: "relative",
            textAlign: "center",
          }}
        >
          <Icon
            baseClassName="material-symbols-outlined"
            sx={{
              display: "block",
              margin: "24px auto",
              color: `${theme.palette.icon.primary}`,
              verticalAlign: "middle",
              fontSize: "3rem",
              mt: 0,
              mb: 1,
              fontWeight: 300,
            }}
          >
            payment
          </Icon>
          <Typography variant="title" sx={{ mb: 1 }}>
            Stanza+
          </Typography>
          {trialPeriodDays > 0 ? (
            <Box sx={{ mt: 0.5, mb: 4 }}>
              <Typography variant="h6">
                {trialPeriodDays} free days
              </Typography>
              <Typography
                variant="subtitle1"
                sx={{ color: "text.primary", mt: 1 }}
              >
                then{" "}
                <span style={{ textDecoration: "line-through" }}>
                  $5.00
                </span>{" "}
                $2.50/mo (billed annually)
              </Typography>
              <CountdownTimer />
            </Box>
          ) : (
            <Typography variant="h6" sx={{ mb: 3 }}>
              Subscribe to Stanza+
            </Typography>
          )}
          <PaymentForm
            type={type}
            trialPeriodDays={trialPeriodDays}
            successUrl={successUrl}
          />
        </Box>
      </div>
    </>
  );
};

export default NativeCheckout;
